import React from 'react'
import FaqItem from './FaqItem.js'
import {Flex, Box} from '@primer/components'

export default () => (
  <Flex as={Box} flexWrap="Wrap" flexDirection="column" maxHeight={["100%", "100%", "100%", "720px"]}>
    <FaqItem
      title="How much time will it take?"
      desc="The time varies depending on the type of research study. An online or in-person appointment typically lasts 30-60 minutes. Sessions will almost always happen during business hours. Other times you’ll be invited to complete a survey which you can complete when it suits you within a given time-range. We’ll always provide you with an estimate of the time involved beforehand."
    />
    <FaqItem
    title="Where does research happen?"
    desc="We primarily conduct remote studies where we can chat with you over the computer. We occasionally also visit different cities to talk with people in-person."
    />
    <FaqItem
    title="Can I opt out?"
    desc="Yes! You can decline any invitation or update your email preferences to opt out from any future emails."
    href="https://github.com/settings/emails"
    link="Update your email preferences in your settings here →"
    />
    <FaqItem
      title="I don't use GitHub, can I still sign up?"
      desc="Yes! We want to hear from current users as well as people who aren’t familiar with GitHub. Sometimes a fresh perspective is just what we’re looking for."
    />
    <FaqItem
    title="Do I need to be a developer?"
    desc="No. Software development teams with people from all kinds of different roles use GitHub: developers, data scientists, QA specialists, product owners, designers, system administrators and more. We welcome your participation!"
    />
    <FaqItem
    title="Who will have access to my information?"
    desc="All your personal information will be kept confidential. It will only be accessible by the GitHub Customer Experience Research team, consistent with our Terms of Service."
    href="https://help.github.com/en/articles/github-research-program-terms"
    link="View terms of service →"
    />
  </Flex>
)
